app.controller('OrderHistoryWebController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {

    const orderHistoryModel = $rootScope.service.order_history.getWebModel()
    $scope.order_request_limit = orderHistoryModel.limit;

    $scope.list_model = new $rootScope.model_constructor.ListModel({
        item_list: orderHistoryModel.choiceList(),
        in_progress: true
    });

    orderHistoryModel.requestOrders(function () {
        $scope.list_model.cloneList(orderHistoryModel.choiceList());
    })

    $scope.showOrder = function (order) {
        $state.go('myba.order-history-web-entry.entry', {order_id: order._id});
    };

    $scope.startNewOrder = function () {
        $rootScope.service.order.startNewOrder();
        $state.go('myba.dashboard');
    }

}]);